import { SET_CURRENT_USER,VALIDATE_CODE } from "../actions/types";

const initialState = {
  validToken: false,
  user: {}
};

const booleanActionPayload = payload => {
  if (payload) {
    return true;
  } else {
    return false;
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        validToken: booleanActionPayload(action.payload),
        user: action.payload
      };
    case VALIDATE_CODE:
        return state; 
     
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/securityReducer.js